import { TColors } from '@cian/ui-kit/colors';
import {
  MetroEkb16,
  MetroKazan16,
  MetroMoscow16,
  MetroNn16,
  MetroNovosib16,
  MetroSamara16,
  MetroSpb16,
} from '@cian/ui-kit/icons';
import * as React from 'react';

import { ECityType } from '../../../../types/newbuildingPromoBuilderOffers';
import * as styles from './styles.css';

interface IUndergroundIconProps {
  lineColor: string;
  undergroundCityType: ECityType;
}

const componentMap = {
  [ECityType.Msk]: MetroMoscow16,
  [ECityType.Spb]: MetroSpb16,
  [ECityType.Samara]: MetroSamara16,
  [ECityType.Ekb]: MetroEkb16,
  [ECityType.Kazan]: MetroKazan16,
  [ECityType.Nizhniy]: MetroNn16,
  [ECityType.Novosib]: MetroNovosib16,
};

export const UndergroundIcon = (props: IUndergroundIconProps) => {
  const { undergroundCityType, lineColor } = props;

  const Icon = componentMap[undergroundCityType];

  if (Icon) {
    return (
      <div className={styles['underground-icon']} data-testid="underground_icon" style={{ color: `#${lineColor}` }}>
        <Icon data-testid={`underground_icon_${undergroundCityType}`} color={'currentColor' as TColors} />
      </div>
    );
  }

  return (
    <div
      className={styles['underground-icon--regions']}
      data-testid="underground_with_custom_icon"
      style={{ color: `#${lineColor}` }}
    />
  );
};
